import { createBrowserRouter, RouterProvider, useSearchParams } from "react-router-dom";
import RootLayout from "./features/app-layout";
// import CalendarView from "./features/calendar-view";
import ApprovalView from "./features/approval-view";
// import HomeView from "./features/home-view";
import AnalyticsView from "./features/analytics-view";
// import CreatePostView from "./features/create-post-view";
import AuthView from "./features/auth-view";
// import LandingView from "./features/landing-view/root-window";
import ContactView from "./features/landing-new/contact-window";
import PreviousView from "./features/previous-post-view";
import SettingsView from "./features/settings-view";
import AuthLayout from "./features/app-layout/AuthLayout";
import RouteProtection from "./features/app-layout/types/RouteProtection";
import PlaygroundView from "./features/playground-view";
import History from "./features/playground-view/components/history-window/History";
import PlaygroundLogin from "./features/app-layout/PlaygroundLogin";
import ErrorView from "./features/error-view";
// import GalleryView from "./features/gallery-view";
import AdminOnboardView from "./features/admin-onboard-view";
// import LandingView from "./features/landing-view/root-window";
import FeedbackView from "./features/admin/feedback-view";
import ReviewSectionView from "./features/review-view";
import AdminGalleryApproval from "./features/admin/gallery-approval-view";
// import LandingNewView from "./features/landing-new/root-window";
import AboutusWindow from "./features/landing-new/about-window";
import InvestorWindow from "./features/landing-new/investor-window";
import InsideWindow from "./features/landing-new/inside-window";
import TermsOfUse from "./features/landing-new/terms-view";
import PrivacyPolicy from "./features/landing-new/privacy-policy-window";
import ImageEditorView from "./features/image-editor-view";
import ExploreWindow from "./features/landing-new/explore-window";
import CreateThemeView from "./features/create-theme-view";
import NewGalleryView from "./features/gallery-new-view"
import LandingReView from "./features/landing-renew";
// import ThreadsView from "./features/threads-view";

const AuthOrPlayground = () => {
  const [searchParams] = useSearchParams();
  const isPlayground = searchParams.get("play") === "true";

  return isPlayground ? <PlaygroundLogin /> : <AuthView />;
};

const AuthOrLanding = () => {
  const url = window.location.hostname;
  if (url === "siai.live" || url === "www.siai.live") {
    return <LandingReView />
  }
  return <AuthOrPlayground />
}

const router = createBrowserRouter([{
  path: '/',
  errorElement: <ErrorView />,
  element: <AuthLayout />
  , children: [
    {
      path: '/home', element: <RouteProtection><RootLayout /></RouteProtection>,
      children: [
        { index: true, element: <ReviewSectionView /> },
        { path: 'create', element: <CreateThemeView /> },
        // { path: 'agenda', element: <CalendarView /> },
        { path: 'approve/:id', element: <ApprovalView /> },
        { path: 'review', element: <ReviewSectionView /> },
        { path: 'analytics', element: <AnalyticsView /> },
        { path: 'previous', element: <PreviousView /> },
        {
          path: 'gallery', children: [
            { index: true, element: <NewGalleryView /> },
            { path: ':imageId', element: <ImageEditorView /> }
          ]
        },
        {
          path: "gallery-new", element: <NewGalleryView />
        },
        { path: 'edit', element: <ImageEditorView /> },
        { path: 'settings', element: <SettingsView /> },
        { path: '_admin/admin-conf', element: <AdminOnboardView /> },
        { path: '_admin/feedback', element: <FeedbackView /> },
        { path: '_admin/gallery-approve', element: <AdminGalleryApproval /> },
        // { path: 'threads', element: <ThreadsView /> },
        {
          path: 'play', children: [
            { index: true, element: <PlaygroundView /> },
            { path: 'history', element: <History /> },
          ]
        },
      ]
    },
    {
      path: '/investors', element: <InvestorWindow />
    },
    {
      path: '/team', element: <AboutusWindow />
    },
    {
      path: '/', element: <AuthOrLanding />
    },
    {
      path: '/explore', element: <ExploreWindow />
    },
    {
      path: '/new', element: <LandingReView />
    },
    {
      path: '/inside', element: <InsideWindow />
    },
    {
      path: '/contact', element: <ContactView />
    },
    {
      path: '/policy', element: <PrivacyPolicy />
    },
    {
      path: '/terms', element: <TermsOfUse />
    },
  ]
}])

const App = () => {
  return (
    <RouterProvider router={router} />
  )
}

export default App;
